var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"header-payout",attrs:{"lg":"4"}},[_c('router-link',{staticClass:"button--primary",attrs:{"to":{ name: _vm.buttonLink }}},[_vm._v(_vm._s(_vm.buttonLabel))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eebbed0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/partials/header/bottombar/HeaderButton.vue
// module id = soIc
// module chunks = 0